import { withGyymAuthRedirect } from './withGyymAuthRedirect'

export const withGyymAuthGuard = (destination: string, permanent = false) => {
  return withGyymAuthRedirect(
    destination,
    (_, { authState }) => !authState.isLoggedIn,
    permanent,
  )
}
